import React, { MouseEvent, useState } from "react";
import DatePicker from "react-datepicker";
import { InputTextBox } from "./InputTextBox";
import "react-datepicker/dist/react-datepicker.css";
import { ja } from "date-fns/locale";
import { format } from "date-fns";
import OutsideClickHandler from "react-outside-click-handler";

export function DateInput(props: Props) {

    const { value, setValue } = props;

    const [isOpen, setIsOpen] = useState(false);

    const handleChange = (e: Date | null) => {
        setIsOpen(!isOpen);
        setValue(e);
    };

    const handleClick = (e: MouseEvent) => {
        e.preventDefault();
        setIsOpen(!isOpen);
    };

    return (
        <>
            <div style={{ position: "relative" }}>
                <InputTextBox
                    value={formatDate(value) ?? ""}
                    handleTextChanged={() => {}}
                    onClick={(e) => handleClick(e)}
                    placeholder={"1950/10/1"}
                />
                {
                    isOpen &&
                        <div style={{ position: "absolute" }}>
                            <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
                                <DatePicker
                                    selected={value}
                                    onChange={handleChange}
                                    locale={ja}
                                    inline
                                    scrollableYearDropdown
                                    showMonthDropdown
                                    showYearDropdown
                                    yearDropdownItemNumber={130}
                                />
                            </OutsideClickHandler>
                        </div>
                }
            </div>
        </>
    );
}

type Props = {
    value: Date | null,
    setValue: (d: Date | null) => void
}

function formatDate(d: Date | null): string | null {
    if (!d) {
        return null;
    }
    return format(d, "yyyy/MM/dd");
}
